var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElementorLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 485.431 249.033 C 485.431 379.106 379.987 484.55 249.914 484.55 C 119.839 484.55 14.394 379.106 14.394 249.033 C 14.394 118.958 119.839 13.513 249.914 13.513 C 379.987 13.513 485.431 118.958 485.431 249.033 Z M 175.021 122.626 L 125.093 122.626 L 125.093 372.263 L 175.021 372.263 L 175.021 122.626 Z M 375.535 322.338 L 224.948 322.338 L 224.948 372.263 L 375.535 372.263 L 375.535 322.338 Z M 375.535 222.48 L 224.948 222.48 L 224.948 272.409 L 375.535 272.409 L 375.535 222.48 Z M 375.535 122.626 L 224.948 122.626 L 224.948 172.553 L 375.535 172.553 L 375.535 122.626 Z",
    style: {
      fill: "rgb(173, 173, 173)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementorLogo);
export default __webpack_public_path__ + "static/media/elementor-logo.d883025cb3489c029162295ee1339809.svg";
export { ForwardRef as ReactComponent };